// extracted by mini-css-extract-plugin
export var container = "GoToTop-module--container--g4VJK";
export var container__icon = "GoToTop-module--container__icon--1d7yu";
export var container__text = "GoToTop-module--container__text--19YQg";